// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import HtmlText from './html-text';
import OtherInstruction from '@deere/cps-it.warranty-model-factory/lib/other-instruction';
import SpecialInstruction from '@deere/cps-it.warranty-model-factory/lib/special-instruction';

const InstructionsList = props => {

    const instructionBlock = props.instructions.map(instruction => instruction.description).join('\n');

    return <HtmlText text={instructionBlock}/>;

};

InstructionsList.displayName = 'InstructionsList';
InstructionsList.propTypes = {
    instructions: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.instanceOf(OtherInstruction),
            PropTypes.instanceOf(SpecialInstruction)
        ])
    ).isRequired
};

export default InstructionsList;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/instructions-panels/instructions-list.js